import axios from "@/axios.js"


function createSDContactsFilterSql(mapper, key, item , campaignId) {
  if (item.operator) {
    var condition1 = mapper(key, item.condition1, campaignId);
    var condition2 = mapper(key, item.condition2 , campaignId);

    return "(" + condition1 + " " + item.operator + " " + condition2 + ")";
  }

  return mapper(key, item ,campaignId);
}


function createCampaignContactFilterSql(mapper, key, item , request) {
  if (item.operator) {
    var condition1 = mapper(key, item.condition1 , request);
    var condition2 = mapper(key, item.condition2 , request);

    return "(" + condition1 + " " + item.operator + " " + condition2 + ")";
  }

  return mapper(key, item ,request);
}









function createFilterSql(mapper, key, item , request) {
  if (item.operator) {      

    let all_conditions = []
    item.conditions.map((condition) => {
      var cond = mapper(key, condition);
      all_conditions.push(cond + " " + item.operator)
    });

    let final_condtion = all_conditions.join(' ')
    // remove last operator
    final_condtion = final_condtion.substring(0, final_condtion.lastIndexOf(" "));

    return "(" + final_condtion + ")";

  }else{

    return mapper(key, item , request);


  }
  }  



  function MatchedCampaignAccountstextFilterMapper(key, item) {
       

    if (key == 'website') {
      key = 'w.url'
    }

    if (key == 'linkedin') {
      key = 'l.url'
    }

    if (key == 'phone') {
      key = 'p.phone_no'
    }


    if (key == 'switchboard') {
      key = 'p.phone_no'
    }

  
    switch (item.type) {
      case "equals":
        return key + " = '" + item.filter + "'";
      case "notEqual":
        return key + "' != '" + item.filter + "'";
      case "contains":
        return key + " ILIKE '%" + item.filter + "%'";
      case "notContains":
        return key + " NOT ILIKE '%" + item.filter + "%'";
      case "startsWith":
        return key + " ILIKE '" + item.filter + "%'";
      case "endsWith":
        return key + " ILIKE '%" + item.filter + "'";
        case "blank":
          let empty_value1 = '[""]'
          return "(" + key + " is NULL or " + key + " = '' or " + key + " = '" + empty_value1 + "')";
      case "notBlank":
        let empty_value = '[""]'
        return "(" + key + " is not NULL and " + key + " != '' and " + key + " != '" + empty_value + "')";
      default:
        console.log("unknown text filter type: " + item.type);
    }
  }


function sDQcTextFilterMapper(key, item) {


  if (key == 'tag') {
    key = 't.tag'
  }

  if (key == 'job_title') {
    key = 'sd_qc_contact.job_title'
  }

  if (key == 'seniority') {
    key = 'sd_qc_contact.seniority'
  }

  if (key == 'sales_developer') {
    key = 'u.first_name'
  }

  switch (item.type) {
    case "equals":
      return key + " = '" + item.filter + "'";
    case "notEqual":
      return key + "' != '" + item.filter + "'";
    case "contains":
      return key + " ILIKE '%" + item.filter + "%'";
    case "notContains":
      return key + " NOT ILIKE '%" + item.filter + "%'";
    case "startsWith":
      return key + " ILIKE '" + item.filter + "%'";
    case "endsWith":
      return key + " ILIKE '%" + item.filter + "'";
      case "blank":
        let empty_value1 = '[""]'
        return "(" + key + " is NULL or " + key + " = '' or " + key + " = '" + empty_value1 + "')";
    case "notBlank":
      let empty_value = '[""]'
      return "(" + key + " is not NULL and " + key + " != '' and " + key + " != '" + empty_value + "')";
    default:
      console.log("unknown text filter type: " + item.type);
  }
}


function sDQcDialFilterMapper(key, item , campaignId) {


  // console.log("Dialing......")
  let all_values = item.values

  // console.log(all_values)
  let statement = []
  let stmt = ''
  if(all_values.length != 0){

    if(all_values.includes("S")){
      statement.push('_d656cacc_af03_4494_af1b_020000413971 is not null')
    }
    // if(all_values.includes("SS")){
    //   statement.push('site_switchboard is not null')
    // }
    if(all_values.includes("DDI")){
      let sd_qc_temp_contact_ddi_table_name = 'sd_qc_contact_ddi_' + campaignId.replaceAll("-", "_")
      statement.push('(select ddi from ' + sd_qc_temp_contact_ddi_table_name + ' where ddi_id = sd_qc_contact._0c483105_8807_4d68_8299_91f449e7085a limit 1  )  is not null')
      // statement.push('ddi is not null')
    }
    if(all_values.includes("Cell")){
      let sd_qc_temp_contact_mobile_table_name = 'sd_qc_contact_mobile_' + campaignId.replaceAll("-", "_")
      statement.push('(select mobile from ' + sd_qc_temp_contact_mobile_table_name + ' where mobile_id = sd_qc_contact._f045b88c_3b21_4a30_9576_f566641e3447 limit 1  )  is not null')
      // statement.push('mobile is not null')
    }
    if(all_values.includes("Others")){
      let sd_qc_temp_account_phone_table_name = 'sd_qc_account_phone_' + campaignId.replaceAll("-", "_")
      statement.push('(select phone_no from ' + sd_qc_temp_account_phone_table_name + ' where phone_id = sd_qc_account._a8bbf05f_56fe_408a_aff0_0f50ce33bf1a limit 1  )  is not null')
    }
  
    stmt = statement.join(' and ')

  

  }else{
    stmt = 'switchboard is null and ddi is null and mobile is null and phone is null and site_switchboard is null';
  }

  

  return stmt
  
}

function textFilterMapper(key, item) {
  if (key == 'seniority') {
    key = 'csl.seniority'
  }
  if (key == 'role') {
    key = 'crl.role'
  }
  if (key == 'sub_role') {
    key = 'csr.sub_role'
  }

  if (key == 'contact_social_media') {
    key = 'csm.social_media'
  }

  switch (item.type) {
    case "equals":
      return key + " = '" + item.filter + "'";
    case "notEqual":
      return key + "' != '" + item.filter + "'";
    case "contains":
      return key + " ILIKE '%" + item.filter + "%'";
    case "notContains":
      return key + " NOT ILIKE '%" + item.filter + "%'";
    case "startsWith":
      return key + " ILIKE '" + item.filter + "%'";
    case "endsWith":
      return key + " ILIKE '%" + item.filter + "'";
      case "blank":
        let empty_value1 = '[""]'
        return "(" + key + " is NULL or " + key + " = '' or " + key + " = '" + empty_value1 + "')";
    case "notBlank":
      let empty_value = '[""]'
      return "(" + key + " is not NULL and " + key + " != '' and " + key + " != '" + empty_value + "')";
    default:
      console.log("unknown text filter type: " + item.type);
  }
}

function campaignContactstextFilterMapper(key, item , request) {

if (request.campaign_contact_none_core_field_ids != null) {
  let text_array = request.campaign_contact_none_core_field_ids.split(',')

  for (let index = 0; index < text_array.length; index++) {
     
    var str = text_array[index].split(".").pop();

    if (key == str) {
      key = text_array[index]
    }


    // if (key == text_array[index]) {
    //   key = 't' + key + '.value'
    //   break
    // }


    // console.log("INCLUDES", key)
    // console.log("text_array", text_array)


      //  if (text_array.includes(key)) {

        
      //       key = 't' + key + '.value'
      //       break
      //     }
  }


}



  if (key == 'forename') {
    key = 'c.forename'
  }
  if (key == 'surname') {
    key = 'c.surname'
  }

  if (key == 'job_title') {
    key = 'cjt.job_title'
  }

  if (key == 'contact_social_media') {
    key = 'csm.social_media'
  }

  if (key == 'seniority') {
    key = 'csl.seniority'
  }
  if (key == 'role') {
    key = 'crl.role'
  }
  if (key == 'sub_role') {
    key = 'csr.sub_role'
  }

  if (key == 'email') {
    key = 'ce.email'
  }

  if (key == 'social_media') {
    key = 'csm.social_media'
  }

  if (key == 'ddi') {
    key = 'cd.ddi'
  }


  if (key == 'mobile') {
    key = 'cm.mobile'
  }

  switch (item.type) {
    case "equals":
      return key + " = '" + item.filter + "'";
    case "notEqual":
      return key + "' != '" + item.filter + "'";
    case "contains":
      return key + " ILIKE '%" + item.filter + "%'";
    case "notContains":
      return key + " NOT ILIKE '%" + item.filter + "%'";
    case "startsWith":
      return key + " ILIKE '" + item.filter + "%'";
    case "endsWith":
      return key + " ILIKE '%" + item.filter + "'";
      case "blank":
        let empty_value1 = '[""]'
        return "(" + key + " is NULL or " + key + " = '' or " + key + " = '" + empty_value1 + "')";
    case "notBlank":
      let empty_value = '[""]'
      return "(" + key + " is not NULL and " + key + " != '' and " + key + " != '" + empty_value + "')";
    default:
      console.log("unknown text filter type: " + item.type);
  }
}

function dateFilterMapper(key, item) {


  console.log("DATE FILTER", item)
  switch (item.type) {
    case "equals":
      return key + " = '" + item.dateFrom + "'";
    case "notEqual":
      return key + " != '" + item.dateFrom + "'";
    case "greaterThan":
      return key + " > '" + item.dateFrom + "'";
    case "greaterThanOrEqual":
      return key + " >= '" + item.dateFrom + "'";
    case "lessThan":
      return key + " < '" + item.dateFrom + "'";
    case "lessThanOrEqual":
      return key + " <= '" + item.dateFrom + "'";
      case "blank":
        return key + " is NULL";
      case "notBlank":
        return key + " is not NULL";
     case "inRange":
      return (
        "(" +
        key +
        " >= '" +
        item.dateFrom +
        "' and " +
        key +
        " <= '" +
        item.dateTo +
        "')"
      );
    default:
      console.log("unknown number filter type: " + item.type);
  }
}

function numberFilterMapper(key, item) {
  switch (item.type) {
    case "equals":
      return key + " = " + item.filter;
    case "notEqual":
      return key + " != " + item.filter;
    case "greaterThan":
      return key + " > " + item.filter;
    case "greaterThanOrEqual":
      return key + " >= " + item.filter;
    case "lessThan":
      return key + " < " + item.filter;
    case "lessThanOrEqual":
      return key + " <= " + item.filter;
    case "inRange":
      return (
        "(" +
        key +
        " >= " +
        item.filter +
        " and " +
        key +
        " <= " +
        item.filterTo +
        ")"
      );
      case "blank":
        return key + " is NULL";
      case "notBlank":
        return key + " is not NULL";
    default:
      console.log("unknown number filter type: " + item.type);
  }
}

export default {
  temp_campaign_table_name: null,
  getData(request, resultsCallback) {
    const SQL = this.buildSql(request, 'accounts_for_campaign');

    // console.log(SQL)
    axios.post("/api/accounts/get_accounts/accounts_for_campaign", {
      sql: SQL
    })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })


    // connection.query(SQL, (error, results) => {
    //   const rowCount = this.getRowCount(request, results);
    //   const resultsForPage = this.cutResultsToPageSize(request, results);
    //   resultsCallback(resultsForPage, rowCount);
    // });
  },

  getAllDBData(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_all_db_accounts');
    // console.log(SQL)
    axios.post("/api/accounts/get_all_db_accounts", {
        sql: SQL,
      })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })

    // connection.query(SQL, (error, results) => {
    //   const rowCount = this.getRowCount(request, results);
    //   const resultsForPage = this.cutResultsToPageSize(request, results);
    //   resultsCallback(resultsForPage, rowCount);
    // });
  },
  getRemainAccountsData(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_remain_accounts');

    axios.post("/api/accounts/get_remain_accounts", {
      sql: SQL
    })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })

    // connection.query(SQL, (error, results) => {
    //   const rowCount = this.getRowCount(request, results);
    //   const resultsForPage = this.cutResultsToPageSize(request, results);
    //   resultsCallback(resultsForPage, rowCount);
    // });
  },
  getRejectedAccountsData(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_rejected_accounts');

    axios.post("/api/accounts/get_rejected_accounts", {
      sql: SQL
    })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })

    // connection.query(SQL, (error, results) => {
    //   const rowCount = this.getRowCount(request, results);
    //   const resultsForPage = this.cutResultsToPageSize(request, results);
    //   resultsCallback(resultsForPage, rowCount);
    // });
  },
  getExistingAccountsForCampaignData(request, resultsCallback) {
    const SQL = this.buildSql(request, 'existing_accounts_for_campaign');
    // console.log(SQL)
    axios.post("/api/accounts/get_accounts/existing_accounts_for_campaign", {
      sql: SQL
    })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })

    // connection.query(SQL, (error, results) => {
    //   const rowCount = this.getRowCount(request, results);
    //   const resultsForPage = this.cutResultsToPageSize(request, results);
    //   resultsCallback(resultsForPage, rowCount);
    // });
  },
  getExtraEnrichedData(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_extra_enriched_accounts');
    // console.log(SQL)

    axios.post("/api/accounts/get_accounts/get_extra_enriched_accounts", {
      sql: SQL
    })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })

    // connection.query(SQL, (error, results) => {
    //   const rowCount = this.getRowCount(request, results);
    //   const resultsForPage = this.cutResultsToPageSize(request, results);
    //   resultsCallback(resultsForPage, rowCount);
    // });
  },
  fetchAllSDQCAccounts(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_sd_qc_accounts');
    // console.log("SD ACCOUNT", SQL)
    if (request.selected_contact_id == null) {
      localStorage.setItem("LAST_SD_ACCOUNT_SQL", SQL);
    }

    axios.post("/api/accounts/get_sd_qc_accounts", {
      sql: SQL,
      campaign_id: request.campaignId
    })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  fetchAllSDQCContacts(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_sd_qc_contacts');

      axios.post("/api/accounts/get_sd_qc_contacts", {
        sql: SQL,
        campaign_id: request.campaignId
      })
        .then((response) => {
          let response_data = JSON.parse(response.data)

          // const ids = response_data.map(o => o.contact_id)
          // response_data = response_data.filter(({contact_id}, index) => !ids.includes(contact_id, index + 1))

          const rowCount = this.getRowCount(request, response_data);
          const resultsForPage = this.cutResultsToPageSize(request, response_data);
          resultsCallback(resultsForPage, rowCount);
        })
        .catch((error) => {
          console.log(error)
        })
    
    

   

  },
  fetchAllSDQCContactsForChangeGradeFilter(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_sd_qc_contacts_for_change_grade_filter');
    console.log("get_sd_qc_contacts_for_change_grade_filter", SQL)

      axios.post("/api/accounts/get_sd_qc_contacts_for_change_grade_filter", {
        sql: SQL,
        campaign_id: request.campaignId
      })
        .then((response) => {
          let response_data = JSON.parse(response.data)

          // const ids = response_data.map(o => o.contact_id)
          // response_data = response_data.filter(({contact_id}, index) => !ids.includes(contact_id, index + 1))

          const rowCount = this.getRowCount(request, response_data);
          const resultsForPage = this.cutResultsToPageSize(request, response_data);
          resultsCallback(resultsForPage, rowCount);
        })
        .catch((error) => {
          console.log(error)
        })
    
    

   

  },
  fetchAllSDQCContactsForAssignContact(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_sd_qc_contacts_for_assign_contact');

      axios.post("/api/accounts/get_sd_qc_contacts_for_assign_contact", {
        sql: SQL,
        campaign_id: request.campaignId
      })
        .then((response) => {
          let response_data = JSON.parse(response.data)

          // const ids = response_data.map(o => o.contact_id)
          // response_data = response_data.filter(({contact_id}, index) => !ids.includes(contact_id, index + 1))

          const rowCount = this.getRowCount(request, response_data);
          const resultsForPage = this.cutResultsToPageSize(request, response_data);
          resultsCallback(resultsForPage, rowCount);
        })
        .catch((error) => {
          console.log(error)
        })
    
    

   

  },
  getAccountDataSourceForClientView(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_account_data_for_client_view');
    // console.log("Client View Account", SQL)

    if(request.campaignId != undefined){

      axios.post("/api/accounts/get_account_data_for_client_view", {
        sql: SQL,
        campaign_id: request.campaignId
      })
        .then((response) => {
          let response_data = JSON.parse(response.data)
          const rowCount = this.getRowCount(request, response_data);
          const resultsForPage = this.cutResultsToPageSize(request, response_data);
          resultsCallback(resultsForPage, rowCount);
        })
        .catch((error) => {
          console.log(error)
        })
    
    
    }



  },
  getContactDataSourceForClientView(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_contact_data_for_client_view');
    console.log("SD Client Contact", SQL)

    if(request.campaignId != undefined){


    axios.post("/api/accounts/get_contact_data_for_client_view", {
      sql: SQL,
      campaign_id: request.campaignId
    })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
    }

  },
  fetchAllQualityControlAccounts(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_quality_control_accounts');

    axios.post("/api/accounts/get_quality_control_accounts", {
      sql: SQL,
      campaign_id: request.campaignId
    })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })

  },
  fetchAllQualityControlContacts(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_quality_control_contacts');

    axios.post("/api/accounts/get_quality_control_contacts", {
      sql: SQL,
      campaign_id: request.campaignId
    })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })

  },
  fetchAllMasterDBAccountsForCampaign(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_master_db_accounts_for_campaign');
    axios.post("/api/accounts/get_master_db_accounts_for_campaign", {
      sql: SQL , campaign_id: request.campaignId
    })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  fetchAllMatchedAccountsOfCampaign(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_matched_accounts_of_campaign');
    console.log("get_matched_accounts_of_campaign" , SQL)
    axios.post("/api/accounts/get_matched_accounts_of_campaign", {
      sql: SQL , campaign_id: request.campaignId
    })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  fetchAllMatchedAccountsListOfCampaign(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_matched_accounts_list_of_campaign');
    console.log("get_matched_accounts_list_of_campaign" , SQL)
    axios.post("/api/accounts/get_matched_accounts_list_of_campaign", {
      sql: SQL , campaign_id: request.campaignId
    })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  fetchAllMatchedContactOfCampaign(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_matched_contacts_of_campaign');
    axios.post("/api/accounts/get_matched_contacts_of_campaign", {
      sql: SQL , campaign_id: request.campaignId
    })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  fetchAllMatchedAccountAssociatedMasterContacts(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_all_matched_account_associated_master_contacts');
    axios.post("/api/accounts/get_all_matched_account_associated_master_contacts", {
      sql: SQL , campaign_id: request.campaignId
    })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  remainingUnmatchedAccount(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_remaining_unmatched_accounts');

    axios.post("/api/accounts/get_remaining_unmatched_accounts", {
      sql: SQL
    })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })

    // connection.query(SQL, (error, results) => {
    //   const rowCount = this.getRowCount(request, results);
    //   const resultsForPage = this.cutResultsToPageSize(request, results);
    //   resultsCallback(resultsForPage, rowCount);
    // });
  },
  enrichAccountDataToMasterDB(request, resultsCallback) {
    const SQL = this.buildSql(request, 'enrich_account_data_to_master_db');

    axios.post("/api/accounts/enrich_account_data_to_master_db", {
      sql: SQL
    })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })

    // connection.query(SQL, (error, results) => {
    //   const rowCount = this.getRowCount(request, results);
    //   const resultsForPage = this.cutResultsToPageSize(request, results);
    //   resultsCallback(resultsForPage, rowCount);
    // });
  },
  getDBAccountsContacts(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_db_accounts_contacts');
    console.log("SQL", SQL)
    axios.post("/api/accounts/get_db_accounts_contacts", {
      sql: SQL
    })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  fetchDBAccountsList(request, resultsCallback) {
    const SQL = this.buildSql(request, 'get_db_accounts_list');
    console.log("SQL", SQL)
    axios.post("/api/accounts/get_db_accounts_list", {
      sql: SQL
    })
      .then((response) => {
        let response_data = JSON.parse(response.data)
        const rowCount = this.getRowCount(request, response_data);
        const resultsForPage = this.cutResultsToPageSize(request, response_data);
        resultsCallback(resultsForPage, rowCount);
      })
      .catch((error) => {
        console.log(error)
      })
  },
  buildSql(request, method) {


    //  console.log("Reques" ,request)


    let selectSql;
    let fromSql;
    if (method == 'get_remain_accounts') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM " + request.table_name;
    }
    if (method == 'get_remaining_unmatched_accounts') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM " + request.table_name
    }
    if (method == 'enrich_account_data_to_master_db') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM " + request.table_name
    }
    if (method == 'get_rejected_accounts') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM " + request.table_name;
    }
    if (method == 'accounts_for_campaign') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM accounts a left join " + request.table_name + " fca on fca.accepted = a.uuid";
    }
    if (method == 'existing_accounts_for_campaign') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM " + request.table_name + " fca inner join accounts a on a.uuid = fca.accepted";
    }
    if (method == 'get_extra_enriched_accounts') {
      selectSql = this.selectSql(request, method);
      fromSql = " FROM " + request.table_name + " fca inner join accounts a on a.uuid = fca.accepted";
    }

    if (method == 'get_db_accounts_list') {
      selectSql = this.selectSql(request, method);


      let account_none_core_field_statements = ''
      let join_website = ''
      let join_linkedin = ''
      let join_phone = ''

      if (request.enrich_master_account_none_core_field_columns == undefined) {
        location.reload();
        }

      

        if (request.enrich_master_account_none_core_field_columns || request.enrich_master_contact_none_core_field_columns) {
            const parsedobjAccount = request.enrich_master_account_none_core_field_columns.split(',');
            for (let index = 0; index < parsedobjAccount.length; index++) {
              const field_id = parsedobjAccount[index];
              const column_name = '_' + parsedobjAccount[index].replaceAll('-', '_')
              account_none_core_field_statements += 'left join (select string_agg(distinct cafv.value , \',\') as ' + column_name + ', caf.account_id from campaign_account_field caf inner join campaign_account_field_values cafv on cafv.value_id = caf.uuid where caf.field_id = \'' + field_id + '\' group by caf.account_id) acc' + index + ' on acc' + index + '.account_id = a."uuid"'
            }
        }

          if (request.enrich_master_account_website_field_columns) {
              join_website = " left join web w on w.account_id = a.uuid "
          }

          if (request.enrich_master_account_linkedin_field_columns) {
            join_linkedin = " left join linkedin l on l.account_id = a.uuid "
        }
        if (request.enrich_master_account_phone_field_columns || request.enrich_master_account_switchboard_field_columns) {
          join_phone = " join phone p on p.account_id = a.uuid "
      }
    


      fromSql = " FROM accounts a " + account_none_core_field_statements + join_website + join_linkedin + join_phone;
    }




    if (method == 'get_db_accounts_contacts') {
      selectSql = this.selectSql(request, method);


      let account_none_core_field_statements = ''
      let join_website = ''
      let join_linkedin = ''
      let join_phone = ''
      let join_contact_job_title = ''
      let join_contact_social_media = ''
      let join_contact_role = ''
      let join_contact_sub_role = ''
      let join_contact_seniority = ''
      let join_contact_email = ''
      let join_contact_ddi = ''
      let join_contact_mobile = ''
      let contact_none_core_field_statements = ''



      if (request.enrich_master_account_none_core_field_columns == undefined) {
        location.reload();
        }

      

        if (request.enrich_master_account_none_core_field_columns || request.enrich_master_contact_none_core_field_columns) {
            const parsedobjAccount = request.enrich_master_account_none_core_field_columns.split(',');
            for (let index = 0; index < parsedobjAccount.length; index++) {
              const field_id = parsedobjAccount[index];
              const column_name = '_' + parsedobjAccount[index].replaceAll('-', '_')
              account_none_core_field_statements += 'left join (select string_agg(distinct cafv.value , \',\') as ' + column_name + ', caf.account_id from campaign_account_field caf inner join campaign_account_field_values cafv on cafv.value_id = caf.uuid where caf.field_id = \'' + field_id + '\' group by caf.account_id) acc' + index + ' on acc' + index + '.account_id = a."uuid"'
            }
                const parsedobj = request.enrich_master_contact_none_core_field_columns.split(',');
                for (let index = 0; index < parsedobj.length; index++) {
                  const field_id = parsedobj[index];
                  const column_name = '_' + parsedobj[index].replaceAll('-', '_')
                  contact_none_core_field_statements += 'left join (select string_agg(distinct cafv.value , \',\') as ' + column_name + ', caf.contact_id from campaign_contact_field caf inner join campaign_contact_field_values cafv on cafv.value_id = caf.uuid where caf.field_id = \'' + field_id + '\' group by caf.contact_id) con' + index + ' on con' + index + '.contact_id = c."uuid"'
                }
        }

          if (request.enrich_master_account_website_field_columns) {
              join_website = " left join web w on w.account_id = a.uuid "
          }

          if (request.enrich_master_account_linkedin_field_columns) {
            join_linkedin = " left join linkedin l on l.account_id = a.uuid "
        }
        if (request.enrich_master_account_phone_field_columns || request.enrich_master_account_switchboard_field_columns) {
          join_phone = " join phone p on p.account_id = a.uuid "
      }
      if (request.enrich_master_contact_job_title_field_columns) {
        join_contact_job_title = " left join contact_job_title cjt on ac.uuid = cjt.accounts_contacts_id "
      }
      if (request.enrich_master_contact_social_media_field_columns) {
        join_contact_social_media = " left join contact_social_media csm on ac.uuid = csm.accounts_contacts_id "
      }
      if (request.enrich_master_contact_role_field_columns) {
        join_contact_role = " left join contact_role crl on ac.uuid = crl.accounts_contacts_id left join contact_role_list cr on cr.uuid = crl.role "
      }
      if (request.enrich_master_contact_sub_role_field_columns) {
        join_contact_sub_role = " left join contact_role crls on ac.uuid = crls.accounts_contacts_id left join contact_sub_role csr on csr.uuid = crls.sub_role "
      }
      if (request.enrich_master_contact_seniority_field_columns) {
        join_contact_seniority = " left join contact_seniority csl on ac.uuid = csl.accounts_contacts_id join contact_seniority_list cs on cs.uuid = csl.seniority "
      }
      if (request.enrich_master_contact_email_field_columns) {
        join_contact_email = " left join contact_email ce on ac.uuid = ce.accounts_contacts_id "
      }
      if (request.enrich_master_contact_ddi_field_columns) {
        join_contact_ddi = " left join contact_ddi cd on ac.uuid = cd.accounts_contacts_id "
      }
      if (request.enrich_master_contact_mobile_field_columns) {

        join_contact_mobile = " left join contact_mobile cm on ac.uuid = cm.accounts_contacts_id "
      }


      fromSql = " FROM accounts a " + account_none_core_field_statements + " inner join accounts_contacts ac on a.uuid = ac.account_id inner join contacts c on ac.contact_id = c.uuid  " + join_contact_email + join_contact_job_title  + join_contact_mobile + join_contact_role + join_contact_seniority + join_contact_social_media + join_contact_sub_role + join_contact_ddi + contact_none_core_field_statements +  join_website + join_linkedin + join_phone;
    }
    if (method == 'get_all_db_accounts') {
      selectSql = this.selectSql(request, method);
      fromSql = ` from accounts a`;
    }
    if (method == 'get_sd_qc_accounts') {
      let campaign_name = request.campaignName
      let campaign_id = request.campaignId

      let sd_qc_temp_account_table_name = 'sd_qc_account_' + campaign_id.replaceAll("-", "_")
      let sd_qc_temp_contact_table_name = 'sd_qc_contact_' + campaign_id.replaceAll("-", "_")
      selectSql = this.selectSql(request, method);

      if (request.selected_filter_account_tag) {
        fromSql = ` FROM ` + sd_qc_temp_account_table_name + ` sd_qc_account left join ` + sd_qc_temp_contact_table_name + ` sd_qc_contact ON sd_qc_account.account_id = sd_qc_contact.account_id inner join sd_account_tags sct on sct.account_tag_id = sd_qc_account.tag_id 
      inner join tags t on t.uuid = sct.tag `;
      } else {
        fromSql = ` FROM ` + sd_qc_temp_account_table_name + ` sd_qc_account left join ` + sd_qc_temp_contact_table_name + ` sd_qc_contact ON sd_qc_account.account_id = sd_qc_contact.account_id `;
      }


      const whereSql = this.whereSql(request, method);
      const limitSql = this.SDACCOUNTLimitSql(request);
      const orderBySql = this.orderBySql(request, method);
      const groupBySql = this.groupBySql(request);
      return selectSql + fromSql + whereSql + groupBySql + orderBySql + limitSql;

    }

    if (method == 'get_quality_control_accounts') {
      let campaign_name = request.campaignName
      let campaign_id = request.campaignId

      let sd_qc_temp_account_table_name = 'sd_qc_account_' + campaign_id.replaceAll("-", "_")
      let sd_qc_temp_contact_table_name = 'sd_qc_contact_' + campaign_id.replaceAll("-", "_")

      selectSql = this.selectSql(request, method);


      fromSql = ` FROM ` + sd_qc_temp_account_table_name + ` sd_qc_account left join ` + sd_qc_temp_contact_table_name + ` sd_qc_contact ON sd_qc_account.account_id = sd_qc_contact.account_id `;

    }


    if (method == 'get_sd_qc_contacts') {
      let campaign_name = request.campaignName
      let campaign_id = request.campaignId
      let sd_qc_temp_account_table_name = 'sd_qc_account_' + campaign_id.replaceAll("-", "_")
      let sd_qc_temp_contact_table_name = 'sd_qc_contact_' + campaign_id.replaceAll("-", "_")
      selectSql = this.selectSql(request, method);

      if (request.selected_filter_contact_tag) {

        fromSql = ` FROM ` + sd_qc_temp_contact_table_name + ` sd_qc_contact left join ` + sd_qc_temp_account_table_name + ` sd_qc_account ON sd_qc_contact.account_id = sd_qc_account.account_id inner join sd_contact_tags sct on sct.contact_tag_id = sd_qc_contact.tag_id 
        left join "user" u on u.uuid = sd_qc_contact.sales_developer_id
      inner join tags t on t.uuid = sct.tag `;

      } else {

        fromSql = ` FROM ` + sd_qc_temp_contact_table_name + ` sd_qc_contact left join ` + sd_qc_temp_account_table_name + ` sd_qc_account ON sd_qc_contact.account_id = sd_qc_account.account_id  left join "user" u on u.uuid = sd_qc_contact.sales_developer_id
`;


      }

      const whereSql = this.whereSql(request, method);
      const limitSql = this.limitSql(request);
      const orderBySql = this.orderBySql(request, method);
      const groupBySql = this.groupBySql(request);
      return selectSql + fromSql + whereSql + groupBySql + orderBySql + limitSql;

      

    }

    if (method == 'get_sd_qc_contacts_for_change_grade_filter') {
      let campaign_name = request.campaignName
      let campaign_id = request.campaignId
      let sd_qc_temp_account_table_name = 'sd_qc_account_' + campaign_id.replaceAll("-", "_")
      let sd_qc_temp_contact_table_name = 'sd_qc_contact_' + campaign_id.replaceAll("-", "_")
      selectSql = this.selectSql(request, method);

      if (request.selected_filter_contact_tag) {

        fromSql = ` FROM ` + sd_qc_temp_contact_table_name + ` sd_qc_contact left join ` + sd_qc_temp_account_table_name + ` sd_qc_account ON sd_qc_contact.account_id = sd_qc_account.account_id inner join sd_contact_tags sct on sct.contact_tag_id = sd_qc_contact.tag_id 
        inner join "user" u on u.uuid = sd_qc_contact.sales_developer_id
      inner join tags t on t.uuid = sct.tag inner join audit_trial at2 
on at2.contact_id = sd_qc_contact.contact_id and at2.campaign_id = sd_qc_contact.campaign_id and at2.account_id = sd_qc_contact.account_id `;

      } else {

        fromSql = ` FROM ` + sd_qc_temp_contact_table_name + ` sd_qc_contact left join ` + sd_qc_temp_account_table_name + ` sd_qc_account ON sd_qc_contact.account_id = sd_qc_account.account_id  inner join "user" u on u.uuid = sd_qc_contact.sales_developer_id inner join audit_trial at2 
on at2.contact_id = sd_qc_contact.contact_id and at2.campaign_id = sd_qc_contact.campaign_id and at2.account_id = sd_qc_contact.account_id 
`;


      }

      const whereSql = this.whereSql(request, method);
      const limitSql = this.limitSql(request);
      const orderBySql = this.orderBySql(request, method);
      const groupBySql = this.groupBySql(request);
      return selectSql + fromSql + whereSql + groupBySql + orderBySql + limitSql;

      

    }
    if (method == 'get_sd_qc_contacts_for_assign_contact') {
      let campaign_name = request.campaignName
      let campaign_id = request.campaignId
      let sd_qc_temp_account_table_name = 'sd_qc_account_' + campaign_id.replaceAll("-", "_")
      let sd_qc_temp_contact_table_name = 'sd_qc_contact_' + campaign_id.replaceAll("-", "_")
      selectSql = this.selectSql(request, method);

      if (request.selected_filter_contact_tag) {

        fromSql = ` FROM ` + sd_qc_temp_contact_table_name + ` sd_qc_contact left join ` + sd_qc_temp_account_table_name + ` sd_qc_account ON sd_qc_contact.account_id = sd_qc_account.account_id inner join sd_contact_tags sct on sct.contact_tag_id = sd_qc_contact.tag_id 
        left join "user" u on u.uuid = sd_qc_contact.sales_developer_id
      inner join tags t on t.uuid = sct.tag `;

      } else {

        fromSql = ` FROM ` + sd_qc_temp_contact_table_name + ` sd_qc_contact left join ` + sd_qc_temp_account_table_name + ` sd_qc_account ON sd_qc_contact.account_id = sd_qc_account.account_id  left join "user" u on u.uuid = sd_qc_contact.sales_developer_id
`;


      }

      const whereSql = this.whereSql(request, method);
      const limitSql = this.limitSql(request);
      const orderBySql = this.orderBySql(request, method);
      const groupBySql = this.groupBySql(request);
      return selectSql + fromSql + whereSql + groupBySql + orderBySql + limitSql;

      

    }
    if (method == 'get_account_data_for_client_view') {

      if(request.campaignId != undefined){

        let campaign_id = request.campaignId
        let sd_qc_temp_account_table_name = 'client_view_account_' + campaign_id.replaceAll("-", "_")
        let sd_qc_temp_contact_table_name = 'client_view_contact_' + campaign_id.replaceAll("-", "_")
        selectSql = this.selectSql(request, method);
  
        fromSql = ` FROM ` + sd_qc_temp_contact_table_name + ` sd_qc_contact left join ` + sd_qc_temp_account_table_name + ` sd_qc_account ON sd_qc_contact.account_id = sd_qc_account.account_id `;


      }
     

    }
    if (method == 'get_contact_data_for_client_view') {

      if(request.campaignId != undefined){
        let campaign_id = request.campaignId
        let sd_qc_temp_account_table_name = 'client_view_account_' + campaign_id.replaceAll("-", "_")
        let sd_qc_temp_contact_table_name = 'client_view_contact_' + campaign_id.replaceAll("-", "_")
        selectSql = this.selectSql(request, method);

  
          fromSql = ` FROM ` + sd_qc_temp_contact_table_name + ` sd_qc_contact left join ` + sd_qc_temp_account_table_name + ` sd_qc_account ON sd_qc_contact.account_id = sd_qc_account.account_id `;
  
  
      
      }

     

    }
    if (method == 'get_quality_control_contacts') {
      let campaign_name = request.campaignName
      let campaign_id = request.campaignId
      let sd_qc_temp_account_table_name = 'sd_qc_account_' + campaign_id.replaceAll("-", "_")
      let sd_qc_temp_contact_table_name = 'sd_qc_contact_' + campaign_id.replaceAll("-", "_")
      selectSql = this.selectSql(request, method);


      fromSql = ` FROM ` + sd_qc_temp_contact_table_name + ` sd_qc_contact left join ` + sd_qc_temp_account_table_name + ` sd_qc_account ON sd_qc_contact.account_id = sd_qc_account.account_id `;


    }




    if (method == 'get_master_db_accounts_for_campaign') {







          if (localStorage.getItem('campaign_account_none_core_field_columns') == undefined) {
            location.reload();
            }


      let campaign_name = request.campaignName
      let campaign_id = request.campaignId
      let temp_contact_table_name = 'temp_' + campaign_id.replaceAll("-", "_") + '_accounts'
      selectSql = this.selectSql(request, method);


      let account_none_core_field_statements = ''
   
      const parsedobj = request.campaign_account_none_core_field_columns.split(',');
      for (let index = 0; index < parsedobj.length; index++) {
        const field_id = parsedobj[index];
        const column_name = '_' + parsedobj[index].replaceAll('-', '_')
        account_none_core_field_statements += 'left join (select string_agg(distinct cafv.value , \',\') as ' + column_name + ', caf.account_id from campaign_account_field caf inner join campaign_account_field_values cafv on cafv.value_id = caf.uuid where caf.field_id = \'' + field_id + '\' group by caf.account_id) acc' + index + ' on acc' + index + '.account_id = a."uuid"'
      }

      fromSql = " FROM accounts a " + account_none_core_field_statements + " left join web w on w.account_id = a.uuid left join linkedin l on l.account_id = a.uuid left join phone p on p.account_id = a.uuid";
    }

    if (method == 'get_matched_accounts_of_campaign') {
      




      



      let campaign_name = request.campaignName
      let campaign_id = request.campaignId
      let temp_contact_table_name = 'temp_' + campaign_id.replaceAll("-", "_") + '_accounts'
      selectSql = this.selectSql(request, method);


      let account_none_core_field_statements = ''
      let join_website = ''
      let join_linkedin = ''
      let join_phone = ''

      if (request.enrich_master_account_none_core_field_columns == undefined) {
        location.reload();
        }
   
      const parsedobj = request.enrich_master_account_none_core_field_columns.split(',');
      for (let index = 0; index < parsedobj.length; index++) {
        const field_id = parsedobj[index];
        const column_name = '_' + parsedobj[index].replaceAll('-', '_')
        account_none_core_field_statements += 'left join (select string_agg(distinct cafv.value , \',\') as ' + column_name + ', caf.account_id from campaign_account_field caf inner join campaign_account_field_values cafv on cafv.value_id = caf.uuid where caf.campaign_id = \'' + request.campaignId + '\' and caf.field_id = \'' + field_id + '\' group by caf.account_id) acc' + index + ' on acc' + index + '.account_id = a."uuid"'
      }


      if (request.enrich_master_account_website_field_columns) {
        join_website = " left join web w on w.account_id = a.uuid "
    }

    if (request.enrich_master_account_linkedin_field_columns) {
      join_linkedin = " left join linkedin l on l.account_id = a.uuid "
  }
  if (request.enrich_master_account_phone_field_columns || request.enrich_master_account_switchboard_field_columns) {
    join_phone = " join phone p on p.account_id = a.uuid "
}

      fromSql = " FROM accounts a " + account_none_core_field_statements + " inner join campaign_accounts c_a on c_a.account_id = a.uuid and c_a.campaign_id = '" + campaign_id + "'" + join_website + join_linkedin + join_phone;
    }

    if (method == 'get_matched_accounts_list_of_campaign') {



        if (request.campaign_account_none_core_field_columns == undefined) {
          location.reload();
          }


      let campaign_name = request.campaignName
      let campaign_id = request.campaignId
      let temp_contact_table_name = 'temp_' + campaign_id.replaceAll("-", "_") + '_accounts'
      selectSql = this.selectSql(request, method);


      let account_none_core_field_statements = ''
   
      const parsedobj = request.campaign_account_none_core_field_columns.split(',');
      for (let index = 0; index < parsedobj.length; index++) {
        const field_id = parsedobj[index];
        const column_name = '_' + parsedobj[index].replaceAll('-', '_')
        account_none_core_field_statements += 'left join (select string_agg(distinct cafv.value , \',\') as ' + column_name + ', caf.account_id from campaign_account_field caf inner join campaign_account_field_values cafv on cafv.value_id = caf.uuid where caf.campaign_id = \'' + request.campaignId + '\' and caf.field_id = \'' + field_id + '\' group by caf.account_id) acc' + index + ' on acc' + index + '.account_id = a."uuid"'
      }

      fromSql = " FROM accounts a " + account_none_core_field_statements + " inner join campaign_accounts c_a on c_a.account_id = a.uuid and c_a.campaign_id = '" + campaign_id + "' left join web w on w.account_id = a.uuid left join linkedin l on l.account_id = a.uuid left join phone p on p.account_id = a.uuid";

 }





    if (method == 'get_matched_contacts_of_campaign') {
      let campaign_name = request.campaignName
      let campaign_id = request.campaignId
      let temp_contact_table_name = 'temp_' + campaign_id.replaceAll("-", "_") + '_contacts'
      selectSql = this.selectSql(request, method);


  let contact_none_core_field_statements = ''

      const parsedobj = request.campaign_contact_none_core_field_columns.split(',');
      for (let index = 0; index < parsedobj.length; index++) {
        const field_id = parsedobj[index];
        const column_name = '_' + parsedobj[index].replaceAll('-', '_')
        contact_none_core_field_statements += 'left join (select string_agg(distinct cafv.value , \',\') as ' + column_name + ', caf.contact_id from campaign_contact_field caf inner join campaign_contact_field_values cafv on cafv.value_id = caf.uuid where caf.campaign_id = \'' + request.campaignId + '\' and caf.field_id = \'' + field_id + '\' group by caf.contact_id) con' + index + ' on con' + index + '.contact_id = c."uuid"'
      }



      
      fromSql = ` 
     from accounts_contacts ac 
    left join contacts c on ac.contact_id = c.uuid 
    left join accounts a on a.uuid = ac.account_id 
    left join contact_email ce on ac.uuid = ce.accounts_contacts_id 
    left join contact_job_title cjt on ac.uuid = cjt.accounts_contacts_id
    left join contact_mobile cm on ac.uuid = cm.accounts_contacts_id 
    left join contact_ddi cd on ac.uuid = cd.accounts_contacts_id 
    left join contact_seniority cs on ac.uuid = cs.accounts_contacts_id
    left join contact_seniority_list csl on csl.uuid = cs.seniority 
    left join contact_social_media csm on ac.uuid = csm.accounts_contacts_id
    left join contact_role cr on ac.uuid = cr.accounts_contacts_id 
    left join contact_role_list crl on crl.uuid = cr."role" 
    left join contact_sub_role csr on csr.uuid = cr.sub_role ` + contact_none_core_field_statements + `
      inner join campaign_contacts c_c on c_c.contact_id = c.uuid and c_c.campaign_id = '` + campaign_id + `'`;
    }

    if (method == 'get_all_matched_account_associated_master_contacts') {

  


      
      let campaign_name = request.campaignName
      let campaign_id = request.campaignId
      let temp_contact_table_name = 'temp_' + campaign_id.replaceAll("-", "_") + '_contacts'
      selectSql = this.selectSql(request, method);


  let contact_none_core_field_statements = ''

      const parsedobj = request.campaign_contact_none_core_field_columns.split(',');
      for (let index = 0; index < parsedobj.length; index++) {
        const field_id = parsedobj[index];
        const column_name = '_' + parsedobj[index].replaceAll('-', '_')
        contact_none_core_field_statements += 'left join (select string_agg(distinct cafv.value , \',\') as ' + column_name + ', caf.contact_id from campaign_contact_field caf inner join campaign_contact_field_values cafv on cafv.value_id = caf.uuid where caf.field_id = \'' + field_id + '\' group by caf.contact_id) con' + index + ' on con' + index + '.contact_id = c."uuid"'
      }



      
      fromSql = ` 
     from accounts_contacts ac 
    left join contacts c on ac.contact_id = c.uuid 
    left join accounts a on a.uuid = ac.account_id 
    left join contact_email ce on ac.uuid = ce.accounts_contacts_id 
    left join contact_job_title cjt on ac.uuid = cjt.accounts_contacts_id
    left join contact_mobile cm on ac.uuid = cm.accounts_contacts_id 
    left join contact_ddi cd on ac.uuid = cd.accounts_contacts_id 
    left join contact_seniority cs on ac.uuid = cs.accounts_contacts_id
    left join contact_seniority_list csl on csl.uuid = cs.seniority 
    left join contact_social_media csm on ac.uuid = csm.accounts_contacts_id
    left join contact_role cr on ac.uuid = cr.accounts_contacts_id 
    left join contact_role_list crl on crl.uuid = cr."role" 
    left join contact_sub_role csr on csr.uuid = cr.sub_role ` + contact_none_core_field_statements + ` `;
    }

    
    const whereSql = this.whereSql(request, method);
    const limitSql = this.limitSql(request);
    const orderBySql = this.orderBySql(request, method);
    const groupBySql = this.groupBySql(request,method);
    return selectSql + fromSql + whereSql + groupBySql + orderBySql + limitSql;

    

  },
  groupBySql(request,method) {
    var rowGroupCols = request.rowGroupCols;
    var groupKeys = request.groupKeys;

    if (this.isDoingGrouping(rowGroupCols, groupKeys)) {
      var rowGroupCol = rowGroupCols[groupKeys.length];

      return " GROUP BY " + rowGroupCol.id;
    }
    if (method == 'get_master_db_accounts_for_campaign') {
      return " GROUP BY a.uuid " + request.campaign_account_none_core_field_ids;
    }
    if (method == 'get_matched_accounts_of_campaign') {
      return " GROUP BY a.uuid " + request.enrich_master_account_none_core_field_ids;
    }
    if (method == 'get_matched_accounts_list_of_campaign') {
      return " GROUP BY a.uuid " + request.campaign_account_none_core_field_ids;
    }
    if (method == 'get_db_accounts_list') {

    

  
  
    

  
  return " GROUP BY  a.uuid " + request.enrich_master_account_none_core_field_ids;
}
    else if (method == 'get_db_accounts_contacts') {

          let group_by_keys = ''
        

      
      
        if (request.enrich_master_contact_job_title_field_columns) {
          group_by_keys += " , cjt.job_title "
        }
        if (request.enrich_master_contact_social_media_field_columns) {
          group_by_keys += " , csm.social_media "
        }
        if (request.enrich_master_contact_role_field_columns) {
          group_by_keys += " , cr.role "
        }
        if (request.enrich_master_contact_sub_role_field_columns) {

          group_by_keys += " , csr.sub_role "
        }
        if (request.enrich_master_contact_seniority_field_columns) {
          group_by_keys += " , cs.seniority "
        }
        if (request.enrich_master_contact_email_field_columns) {
          group_by_keys += " , ce.email "
        }
        if (request.enrich_master_contact_ddi_field_columns) {
          group_by_keys += " , cd.ddi "
        }
        if (request.enrich_master_contact_mobile_field_columns) {
        group_by_keys += " , cm.mobile "
        }

      
      return " GROUP BY ac.uuid , a.uuid ,c.uuid,ac.ml_id,ac.account_id,ac.contact_id, a.company_name, c.title,  c.forename " + group_by_keys + " , ac.account_id " + request.enrich_master_account_none_core_field_ids + request.enrich_master_contact_none_core_field_ids;
    }
    else if (method == 'get_matched_contacts_of_campaign') {
      return " group by c.uuid,ac.uuid,ac.account_id,ac.contact_id, a.company_name, c.title,  c.forename ,  c.surname,  ce.email,  cjt.job_title, csl.seniority, csm.social_media, crl.role,csr.sub_role " + request.campaign_contact_none_core_field_ids;
    }
    else if (method == 'get_all_matched_account_associated_master_contacts') {
      return " group by c.uuid,ac.uuid,ac.account_id,ac.contact_id, a.company_name, c.title,  c.forename ,  c.surname,  ce.email,  cjt.job_title, csl.seniority, csm.social_media, crl.role,csr.sub_role " + request.campaign_contact_none_core_field_ids;
    }
    else{
      return "";
    }

  },
  getRowCount(request, results) {
    if (results === null || results === undefined || results.length === 0) {
      return null;
    }
    const currentLastRow = request.startRow + results.length;
    return currentLastRow <= request.endRow ? currentLastRow : -1;
  },

  cutResultsToPageSize(request, results) {
    const pageSize = request.endRow - request.startRow;
    if (results && results.length > pageSize) {
      return results.splice(0, pageSize);
    } else {
      return results;
    }
  },
  selectSql(request, method) {
    var rowGroupCols = request.rowGroupCols;
    var valueCols = request.valueCols;
    var groupKeys = request.groupKeys;

    if (this.isDoingGrouping(rowGroupCols, groupKeys)) {
      var rowGroupCol = rowGroupCols[groupKeys.length];
      var colsToSelect = [rowGroupCol.id];

      valueCols.forEach(function (valueCol) {
        colsToSelect.push(
          valueCol.aggFunc + "(" + valueCol.id + ") AS " + valueCol.id
        );
      });

      return "SELECT " + colsToSelect.join(", ");
    } else if (method == 'existing_accounts_for_campaign') {
      return "SELECT * , fca.ml_id as campaign_account_ml_id ";
    } else if (method == 'get_extra_enriched_accounts') {
      return "SELECT DISTINCT * , fca.ml_id as campaign_account_ml_id ";
    } else if (method == 'get_remain_accounts') {
      return "SELECT * ";
    } else if (method == 'get_remaining_unmatched_accounts') {
      return "SELECT * ";
    } else if (method == 'enrich_account_data_to_master_db') {
      return "SELECT * ";
    } else if (method == 'get_rejected_accounts') {
      return "SELECT * ";
    } else if (method == 'get_sd_qc_accounts') {
      return "SELECT distinct sd_qc_account.account_id  , sd_qc_account.* , sd_qc_account.tag_id as account_tag_id , sd_qc_account.campaign_id as account_campaign_id , sd_qc_account.account_id as acc_id , sd_qc_account.sales_developer_id as sales_developer , sd_qc_account.id as table_id";
    }
    else if (method == 'get_quality_control_accounts') {
      return "SELECT * , sd_qc_account.campaign_id as account_campaign_id , sd_qc_account.account_id as acc_id , sd_qc_account.sales_developer_id as sales_developer , sd_qc_account.id as table_id";
    }
    else if (method == 'get_sd_qc_contacts') {
      return "SELECT distinct  sd_qc_contact.contact_id , sd_qc_contact.* , sd_qc_account.* , concat(u.first_name , ' ' , u.surname) as sales_developer, sd_qc_contact.contact_id as new_contact_id,  sd_qc_contact.tag_id as contact_tag_id , sd_qc_contact.campaign_id as account_campaign_id ,sd_qc_contact.tag_id as contact_tag_id, sd_qc_contact.sales_developer_id as contact_sales_developer , sd_qc_contact.id as table_id";

    }
    else if (method == 'get_sd_qc_contacts_for_change_grade_filter') {
      return "SELECT distinct  sd_qc_contact.contact_id , sd_qc_contact.* , sd_qc_account.* , at2.* , concat(u.first_name , ' ' , u.surname) as sales_developer, sd_qc_contact.contact_id as new_contact_id,  sd_qc_contact.tag_id as contact_tag_id , sd_qc_contact.campaign_id as account_campaign_id ,sd_qc_contact.tag_id as contact_tag_id, sd_qc_contact.sales_developer_id as contact_sales_developer , sd_qc_contact.id as table_id";
    }
    else if (method == 'get_sd_qc_contacts_for_assign_contact') {
      return "SELECT distinct  sd_qc_contact.contact_id , sd_qc_contact.* , sd_qc_account.* , concat(u.first_name , ' ' , u.surname) as sales_developer, sd_qc_contact.contact_id as new_contact_id,  sd_qc_contact.tag_id as contact_tag_id , sd_qc_contact.campaign_id as account_campaign_id ,sd_qc_contact.tag_id as contact_tag_id, sd_qc_contact.sales_developer_id as contact_sales_developer , sd_qc_contact.id as table_id";

    }
 else if (method == 'get_account_data_for_client_view') {
    return "SELECT distinct sd_qc_account.account_id, sd_qc_account.id as unique_account_id , sd_qc_account.* , sd_qc_account.campaign_id as account_campaign_id , sd_qc_account.account_id as acc_id , sd_qc_account.id as table_id";
  }
  else if (method == 'get_contact_data_for_client_view') {
    return "SELECT distinct * ,sd_qc_account.id as unique_account_id ,sd_qc_contact.id as unique_contact_id , sd_qc_contact.id as unique_id,sd_qc_contact.campaign_id as account_campaign_id , sd_qc_contact.id as table_id";
  }
    else if (method == 'get_quality_control_contacts') {
      return "SELECT * , sd_qc_contact.campaign_id as account_campaign_id , sd_qc_contact.sales_developer_id as contact_sales_developer , sd_qc_contact.id as table_id";
    }
    else if (method == 'get_matched_accounts_of_campaign') {


      console.log("phone", request.enrich_master_account_phone_field_columns)
     
      return "SELECT a.* " + request.enrich_master_account_none_core_field_ids + request.enrich_master_account_switchboard_field_columns + request.enrich_master_account_phone_field_columns + request.enrich_master_account_linkedin_field_columns + request.enrich_master_account_website_field_columns + ",  a.uuid as account_id";
    
    }
    else if (method == 'get_matched_accounts_list_of_campaign') {


      return "SELECT a.* , string_agg(distinct w.url, ',') as website " + request.campaign_account_none_core_field_ids + ", string_agg(distinct l.url, ',') as linkedin,(select nullif(concat_ws(' , ',nullif(concat_ws(' , ' , string_agg(distinct p.phone_no  , ' , ')) , ' , ')) , ' , ') from phone ph  limit 1 ) as phone, (select nullif(concat_ws(' , ',nullif(concat_ws(' , ' , string_agg(distinct p.phone_no  , ' , ')) , ' , ')) , ' , ') from phone ph  limit 1 ) as switchboard,  a.uuid as account_id";
    }
    else if (method == 'get_master_db_accounts_for_campaign') {
     
      return "SELECT a.* , string_agg(distinct w.url, ',') as website " + request.campaign_account_none_core_field_ids + ", string_agg(distinct l.url, ',') as linkedin,(select nullif(concat_ws(' , ',nullif(concat_ws(' , ' , string_agg(distinct p.phone_no  , ' , ')) , ' , ')) , ' , ') from phone ph  limit 1 ) as phone, (select nullif(concat_ws(' , ',nullif(concat_ws(' , ' , string_agg(distinct p.phone_no  , ' , ')) , ' , ')) , ' , ') from phone ph  limit 1 ) as switchboard,  a.uuid as account_id";
    
    } else if (method == 'get_matched_contacts_of_campaign') {
      return ` SELECT distinct c.uuid,ac.account_id
      ` + request.campaign_contact_none_core_field_ids + `,
      ac.contact_id,
      a.company_name,
      c.title as title,
      c.forename as forename,
      c.surname as surname,
      cjt.job_title as job_title,
      csl.seniority as seniority,
      crl."role" as role,
      csr.sub_role as sub_role `;
    } 
    else if (method == 'get_all_matched_account_associated_master_contacts') {
      return ` SELECT distinct c.uuid,ac.account_id
      ` + request.campaign_contact_none_core_field_ids + `,
      ac.contact_id,
      a.company_name,
      c.title as title,
      c.forename as forename,
      c.surname as surname,
      (Select ce.email from contact_email ce where ce.accounts_contacts_id = ac.uuid limit 1),
      cjt.job_title as job_title,
      (select nullif(concat_ws(' , ',nullif(concat_ws(' , ' , string_agg(distinct cm.mobile  , ' , ')) , ' , ')) , ' , ') from contact_mobile cm where cm.accounts_contacts_id = ac.uuid limit 1 ) as mobile,
      (select nullif(concat_ws(' , ',nullif(concat_ws(' , ' , string_agg(distinct cd.ddi  , ' , ')) , ' , ')) , ' , ') from contact_ddi cd where cd.accounts_contacts_id = ac.uuid limit 1 ) as ddi,
      csl.seniority as seniority,
      (select nullif(concat_ws(' , ',nullif(concat_ws(' , ' , string_agg(distinct csm.social_media  , ' , ')) , ' , ')) , ' , ') from contact_social_media csm where csm.accounts_contacts_id = ac.uuid limit 1 ) as contact_social_media,
      crl."role" as role,
      csr.sub_role as sub_role `;
    }
    else if (method == 'get_db_accounts_list') {
      return "SELECT distinct a.uuid " + request.enrich_master_account_switchboard_field_columns + request.enrich_master_account_phone_field_columns + request.enrich_master_account_linkedin_field_columns + request.enrich_master_account_website_field_columns + request.enrich_master_account_core_field_columns + request.enrich_master_account_none_core_field_ids + ",  a.uuid as account_id ";
    }
    else if (method == 'get_db_accounts_contacts') {
      return "SELECT distinct ac.uuid, ac.account_id  " + request.enrich_master_account_switchboard_field_columns + request.enrich_master_account_phone_field_columns + request.enrich_master_account_linkedin_field_columns + request.enrich_master_account_website_field_columns + request.enrich_master_contact_job_title_field_columns + request.enrich_master_contact_email_field_columns + request.enrich_master_contact_mobile_field_columns + request.enrich_master_contact_ddi_field_columns + request.enrich_master_contact_social_media_field_columns + request.enrich_master_contact_role_field_columns + request.enrich_master_contact_sub_role_field_columns + request.enrich_master_contact_seniority_field_columns + request.enrich_master_contact_core_field_columns + request.enrich_master_account_core_field_columns + request.enrich_master_contact_none_core_field_ids + " ,ac.contact_id " + request.enrich_master_account_none_core_field_ids + ",  a.uuid as account_id ";
    } else {
      return "SELECT a.*";
    }
    
    },
  whereSql(request, method) {
    var whereParts = [];
    var filterModel = request.filterModel;

    if (method == 'get_remain_accounts') {
      whereParts.push("accepted is null and added_to_db is null and rejected is null")
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }

    if (method == 'get_remaining_unmatched_accounts') {
      whereParts.push("accepted is null")
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    if (method == 'enrich_account_data_to_master_db') {
      whereParts.push("accepted is not null")
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }


    if (method == 'get_rejected_accounts') {
      whereParts.push("rejected is not null and added_to_db is null and accepted is null")
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }

    if (method == 'accounts_for_campaign') {
      // whereParts.push("fca.accepted is null")
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          key = 'a.' + key
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    } else if (method == 'existing_accounts_for_campaign') {
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          key = 'a.' + key
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    } else if (method == 'get_extra_enriched_accounts') {
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }
    } 
    else if (method == 'get_db_accounts_list') {
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {


          var item = filterModel[key];

          if (key == 'contact-campaign-status') {


          }else{


            switch (item.filterType) {
              case "text":
                whereParts.push(createFilterSql(textFilterMapper, key, item));
                break;
              case "number":
                if(request.enrich_none_core_number_type_ids.includes(key)){
                  key = key + '::bigint'
                }
                whereParts.push(createFilterSql(numberFilterMapper, key, item));
                break;
              case "date":
                whereParts.push(createFilterSql(dateFilterMapper, key, item));
                break;
              default:
                console.log("unknown filter type: " + item.filterType);
                break;
            }
          
          
          }





       
        });
      }
    }
    
    else if (method == 'get_db_accounts_contacts') {
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {


          var item = filterModel[key];

          if (key == 'contact-campaign-status') {


          }else{


            switch (item.filterType) {
              case "text":
                whereParts.push(createFilterSql(textFilterMapper, key, item));
                break;
              case "number":
                if(request.enrich_none_core_number_type_ids.includes(key)){
                  key = key + '::bigint'
                }
                whereParts.push(createFilterSql(numberFilterMapper, key, item));
                break;
              case "date":
                whereParts.push(createFilterSql(dateFilterMapper, key, item));
                break;
              default:
                console.log("unknown filter type: " + item.filterType);
                break;
            }
          
          
          }





       
        });
      }
    } else if (method == 'get_sd_qc_accounts') {

      if (request.selected_filter_account_tag != undefined) {
        var arrString = request.selected_filter_account_tag.map(function (b) {
          return "'" + b + "'";
        });

        whereParts.push(" t.uuid IN (" + arrString + ")")
      }

      if (request.userId != undefined) {
        whereParts.push(" sd_qc_account.sales_developer_id = '" + request.userId + "'")
      }
      if (request.selected_contact_id != null) {
        whereParts.push(" sd_qc_contact.contact_id = '" + request.selected_contact_id + "'")
      }
      whereParts.push(" sd_qc_account.account_status = 'in_market'")
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(sDQcTextFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_quality_control_accounts') {

      if (request.selected_filter_account_tag != undefined) {
        var arrString = request.selected_filter_account_tag.map(function (b) {
          return "'" + b + "'";
        });

        whereParts.push(" t.uuid IN (" + arrString + ")")
      }

      if (request.selected_contact_id != null) {
        whereParts.push(" sd_qc_contact.contact_id = '" + request.selected_contact_id + "'")
      }
      // whereParts.push(" sd_qc_account.account_status = 'in_market'")
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(sDQcTextFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    } else if (method == 'get_master_db_accounts_for_campaign') {

      
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(MatchedCampaignAccountstextFilterMapper, key, item));
              break;
            case "number":
              if(request.enrich_none_core_number_type_ids.includes(key)){
                key = key + '::bigint'
              }
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_matched_accounts_of_campaign') {


        if (request.new_selected_account_ids_to_campaign != undefined) {

          whereParts.push(" a.uuid IN (" + request.new_selected_account_ids_to_campaign + ")")

         
        }




     


      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(MatchedCampaignAccountstextFilterMapper, key, item));
              break;
            case "number":
              if(request.enrich_none_core_number_type_ids.includes(key)){
                key = key + '::bigint'
              }
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_matched_accounts_list_of_campaign') {


      if (request.new_selected_account_ids_to_campaign != undefined) {

        whereParts.push(" a.uuid IN (" + request.new_selected_account_ids_to_campaign + ")")

       
      }




   


    if (filterModel) {
      Object.keys(filterModel).forEach(function (key) {
        var item = filterModel[key];
        switch (item.filterType) {
          case "text":
            whereParts.push(createFilterSql(MatchedCampaignAccountstextFilterMapper, key, item));
            break;
          case "number":
            if(request.enrich_none_core_number_type_ids.includes(key)){
              key = key + '::bigint'
            }
            whereParts.push(createFilterSql(numberFilterMapper, key, item));
            break;
          case "date":
            whereParts.push(createFilterSql(dateFilterMapper, key, item));
            break;
          default:
            console.log("unknown filter type: " + item.filterType);
            break;
        }
      });
    }

  } else if (method == 'get_sd_qc_contacts') {

      if (request.selected_filter_contact_tag != undefined) {
        var arrString = request.selected_filter_contact_tag.map(function (b) {
          return "'" + b + "'";
        });

        whereParts.push(" t.uuid IN (" + arrString + ")")
      }

      if (request.userId != undefined) {
        whereParts.push(" sd_qc_contact.sales_developer_id = '" + request.userId + "'")
      }
      if (request.selected_account_id != null) {
        whereParts.push(" sd_qc_contact.account_id = '" + request.selected_account_id + "'")
      }
      if (request.sales_developer_id != undefined) {
        whereParts.push(" sd_qc_contact.sales_developer_id = '" + request.sales_developer_id + "'")
      }
      




      if (request.all_sales_developer != "Yes") {
        whereParts.push("sd_qc_contact.contact_status = 'in_market'")
      }






      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(sDQcTextFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            case "set":
              whereParts.push(createSDContactsFilterSql(sDQcDialFilterMapper, key, item , request.campaignId));
              break;
            default:
              break;
          }
        });
      }

  } 
  
  else if (method == 'get_sd_qc_contacts_for_change_grade_filter') {

    if (request.selected_filter_contact_tag != undefined) {
      var arrString = request.selected_filter_contact_tag.map(function (b) {
        return "'" + b + "'";
      });

      whereParts.push(" t.uuid IN (" + arrString + ")")
    }

    if (request.userId != undefined) {
      whereParts.push(" sd_qc_contact.sales_developer_id = '" + request.userId + "'")
    }
    if (request.selected_account_id != null) {
      whereParts.push(" sd_qc_contact.account_id = '" + request.selected_account_id + "'")
    }
    if (request.sales_developer_id != undefined) {
      whereParts.push(" sd_qc_contact.sales_developer_id = '" + request.sales_developer_id + "'")
    }
    




    if (request.all_sales_developer != "Yes") {
      whereParts.push("sd_qc_contact.contact_status = 'in_market'")
    }


    if (request.filter_start_date_time != undefined && request.filter_end_date_time != undefined) {
      whereParts.push("at2.date_time >= '" + request.filter_start_date_time + "' and at2.date_time <= '" + request.filter_end_date_time + "'")
      
    }
    




    if (filterModel) {
      Object.keys(filterModel).forEach(function (key) {
        var item = filterModel[key];
        switch (item.filterType) {
          case "text":
            whereParts.push(createFilterSql(sDQcTextFilterMapper, key, item));
            break;
          case "number":
            whereParts.push(createFilterSql(numberFilterMapper, key, item));
            break;
          case "date":
            whereParts.push(createFilterSql(dateFilterMapper, key, item));
            break;
          case "set":
            whereParts.push(createSDContactsFilterSql(sDQcDialFilterMapper, key, item , request.campaignId));
            break;
          default:
            break;
        }
      });
    }

}
  else if (method == 'get_sd_qc_contacts_for_assign_contact') {

    if (request.selected_filter_contact_tag != undefined) {
      var arrString = request.selected_filter_contact_tag.map(function (b) {
        return "'" + b + "'";
      });

      whereParts.push(" t.uuid IN (" + arrString + ")")
    }

    if (request.userId != undefined) {
      whereParts.push(" sd_qc_contact.sales_developer_id = '" + request.userId + "'")
    }
    if (request.selected_account_id != null) {
      whereParts.push(" sd_qc_contact.account_id = '" + request.selected_account_id + "'")
    }
    if (request.sales_developer_id != undefined) {
      whereParts.push(" sd_qc_contact.sales_developer_id = '" + request.sales_developer_id + "'")
    }
    





    if (filterModel) {
      Object.keys(filterModel).forEach(function (key) {
        var item = filterModel[key];
        switch (item.filterType) {
          case "text":
            whereParts.push(createFilterSql(sDQcTextFilterMapper, key, item));
            break;
          case "number":
            whereParts.push(createFilterSql(numberFilterMapper, key, item));
            break;
          case "date":
            whereParts.push(createFilterSql(dateFilterMapper, key, item));
            break;
          case "set":
            whereParts.push(createSDContactsFilterSql(sDQcDialFilterMapper, key, item , request.campaignId));
            break;
          default:
            break;
        }
      });
    }

  }
    else if (method == 'get_account_data_for_client_view') {

      if (request.selected_contact_id != null) {
        whereParts.push(" sd_qc_contact.contact_id = '" + request.selected_contact_id + "'")
      }
      // whereParts.push(" sd_qc_account.account_status = 'in_market'")
      whereParts.push(" sd_qc_account.campaign_id is not NULL ")

      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(sDQcTextFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_contact_data_for_client_view') {

      if (request.selected_filter_contact_tag != undefined) {
        var arrString = request.selected_filter_contact_tag.map(function (b) {
          return "'" + b + "'";
        });

        whereParts.push(" t.uuid IN (" + arrString + ")")
      }

      if (request.selected_account_id != null) {
        whereParts.push(" sd_qc_contact.account_id = '" + request.selected_account_id + "'")
      }
      // whereParts.push(" sd_qc_contact.contact_status = 'in_market'")
      whereParts.push(" sd_qc_contact.campaign_id is not NULL ")


      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(sDQcTextFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_quality_control_contacts') {

      if (request.selected_filter_contact_tag != undefined) {
        var arrString = request.selected_filter_contact_tag.map(function (b) {
          return "'" + b + "'";
        });

        whereParts.push(" t.uuid IN (" + arrString + ")")
      }
      if (request.selected_account_id != null) {
        whereParts.push(" sd_qc_contact.account_id = '" + request.selected_account_id + "'")
      }
      if (request.sales_developer_id != undefined) {
        whereParts.push(" sd_qc_contact.sales_developer_id = '" + request.sales_developer_id + "'")
      }
      // whereParts.push(" sd_qc_contact.contact_status = 'in_market'")

      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(sDQcTextFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    } else if (method == 'get_matched_contacts_of_campaign') {
      if (request.selected_accounts.length != 0) {
        var arrString = request.selected_accounts.map(function (b) {
          return "'" + b + "'";
        });


        whereParts.push(" ac.account_id IN (" + arrString + ")")

      }
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {

          
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createCampaignContactFilterSql(campaignContactstextFilterMapper, key, item , request));
              break;
            case "number":
              if(request.enrich_none_core_number_type_ids.includes(key)){
                key = key + '::bigint'
              }
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else if (method == 'get_all_matched_account_associated_master_contacts') {
      if (request.selected_accounts.length != 0) {
        var arrString = request.selected_accounts.map(function (b) {
          return "'" + b + "'";
        });


        whereParts.push(" ac.account_id IN (" + arrString + ")")

      }
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createCampaignContactFilterSql(campaignContactstextFilterMapper, key, item , request));
              break;
            case "number":


              console.log("request.enrich_none_core_number_type_ids", request.enrich_none_core_number_type_ids)

              if(request.enrich_none_core_number_type_ids.includes(key)){
                key = key + '::bigint'
              }
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }

    }
    else {
      if (filterModel) {
        Object.keys(filterModel).forEach(function (key) {
          var item = filterModel[key];
          switch (item.filterType) {
            case "text":
              whereParts.push(createFilterSql(textFilterMapper, key, item));
              break;
            case "number":
              whereParts.push(createFilterSql(numberFilterMapper, key, item));
              break;
            case "date":
              whereParts.push(createFilterSql(dateFilterMapper, key, item));
              break;
            default:
              console.log("unknown filter type: " + item.filterType);
              break;
          }
        });
      }
    }


    if (whereParts.length > 0) {
      return " WHERE " + whereParts.join(" AND ");
    }

    return "";
  },
  isDoingGrouping(rowGroupCols, groupKeys) {
    // we are not doing grouping if at the lowest level
    return rowGroupCols.length > groupKeys.length;
  },
  orderBySql(request, method) {
    var sortModel = request.sortModel;



        // if (request.sortModel[0]['colId'] == 'sales_developer') {
        //   // request.sortModel[0]['colId'] = 'sd_qc_account.sales_developer_id'
        // }


    if (method == 'get_master_db_accounts_for_campaign') {
      if (sortModel.length === 0) return "";
    }
    else if (method == 'get_matched_accounts_of_campaign') {
      if (sortModel.length === 0) return "";
    }
    else if (method == 'get_matched_accounts_list_of_campaign') {
      if (sortModel.length === 0) return "";
    }
    else if (method == 'get_sd_qc_contacts' || method == 'get_sd_qc_contacts_for_change_grade_filter' || method == 'get_contact_data_for_client_view' || method == 'get_sd_qc_contacts_for_assign_contact') {
    
      if (sortModel.length === 0) return ""
      else {
        var sorts = sortModel.map(function (s) {



          return s.colId + " " + s.sort.toUpperCase();
        });
        return " ORDER BY " + sorts.join(", ") + " NULLS LAST ";
      }
    }else {
      if (sortModel.length === 0) return "";
    }

    var sorts = sortModel.map(function (s) {
      return s.colId + " " + s.sort.toUpperCase();
    });

    return " ORDER BY " + sorts.join(", ") + " NULLS LAST ";
  },
  limitSql(request) {


    var blockSize = request.endRow - request.startRow;

    return " LIMIT " + (blockSize + 1) + " OFFSET " + request.startRow;



  },
  SDACCOUNTLimitSql(request) {


    if (request.selected_contact_id != null) {

      var blockSize = request.endRow - request.startRow;


      return " LIMIT " + (blockSize + 1) + " OFFSET 0 ";

    }else{

      var blockSize = request.endRow - request.startRow;

    return " LIMIT " + (blockSize + 1) + " OFFSET " + request.startRow;

    }

     



  },
  SDContactLimitSql(request) {


    if (request.selected_account_id != null) {

      var blockSize = request.endRow - request.startRow;


      return " LIMIT " + (blockSize + 1) + " OFFSET 0 ";

    }else{

      var blockSize = request.endRow - request.startRow;

    return " LIMIT " + (blockSize + 1) + " OFFSET " + request.startRow;

    }

     



  },
  getLastRowIndex(request, results) {
    if (!results || results.length === 0) {
      return request.startRow;
    }

    var currentLastRow = request.startRow + results.length;

    return currentLastRow <= request.endRow ? currentLastRow : -1;
  }

  // helper methods ...
};
